<template>
  <div class="deals-menu">
    <div class="extended-block">
      <h6>Diligence</h6>
      <menu-item
        v-if="isCipeEnabled"
        path="/matching/ethics-1st"
        text="Ethics 1st"
        caption="Ethics 1st is a platform for African businesses looking to build global recognition and gain trust with global investors and business partners"
        @click="handleItemClick('/matching/ethics-1st')"
      />
    </div>
    <div class="extended-block">
      <h6>Deals</h6>
      <menu-item
        path="/matching/marketplaces"
        text="DealRooms"
        caption="Finance & Invest in African (High-Growth) Companies"
        @click="handleItemClick('/matching/marketplaces')"
      />
      <menu-item
        path="/deals/gabon-virtual-dealroom/investor"
        text="Gabon VDR"
        caption="The Gabon VDR initiative aims to encourage private investors focused on the African continent to seize the many business opportunities in Gabon"
        @click="handleItemClick('/deals/gabon-virtual-dealroom/investor')"
      />
    </div>
    <!-- <div class="extended-block">
      <h6>Your deals</h6>
      <user-menu-item
        path="/deals/submissions"
        text="My deals"
        caption="Sign in track your deal history"
        @click="handleItemClick"
      />
    </div> -->
    <!-- <div class="extended-block">
      <div class="promo-header">
        <h6>Latest deal news</h6>
        <router-link>View all</router-link>
      </div>
      <deal-promo />
    </div> -->
  </div>
</template>

<script>
import MenuItem from './menu-item'
// import UserMenuItem from './user-menu-item'
// import DealPromo from './deal-promo'

export default {
  name: 'deals-menu',
  components: {
    MenuItem,
    // UserMenuItem,
    // DealPromo,
  },
  computed: {
    isCipeEnabled() {
      return this.$store.getters.isCipeEnabled
    },
  },
  methods: {
    handleItemClick(path) {
      this.$emit('hide')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'top-menu-navigate',
        eventLabel: 'Path ' + path,
      })
      this.$gtag.event('top-menu-navigate', {
        'event_category': 'Click',
        'event_label': 'Path ' + path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.deals-menu {
  display: flex;
  flex-direction: column;
  padding: 0 $padding-l;
  @include desktop {
    flex-direction: row;
    min-width: 600px;
  }
}
.extended-block {
  padding: $padding-l $padding-m;
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
  }
}
.user-block {
  padding: $padding-l $padding-m;
  background: #fffae9;
}
</style>
